import React, { useEffect } from 'react';
import { X } from 'lucide-react';

// Right-hand side panel used by the planner's dialogs (day panel, fixture form, block editor, ...).
// Escape or a click on the backdrop closes it.
export default function PlannerOverlay({ title, onClose, children, width = 420 }) {
  useEffect(() => {
    const onKey = e => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);
  return (
    <div role="presentation" onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 1000, display: 'flex', justifyContent: 'flex-end' }}>
      <div role="dialog" aria-modal="true" aria-label={title} onClick={e => e.stopPropagation()}
        style={{ width: `min(${width}px, 100vw)`, height: '100%', overflowY: 'auto', background: 'var(--bg-card)', borderLeft: '1px solid var(--border-strong)', padding: 18, boxSizing: 'border-box', display: 'flex', flexDirection: 'column', gap: 14 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, flex: 1 }}>{title}</h3>
          <button className="pl-btn" aria-label="Close" onClick={onClose}><X size={15} /></button>
        </div>
        {children}
      </div>
    </div>
  );
}
